import { Check, CheckCheck, ClipboardPaste, RefreshCw } from "lucide-react";
import moment from "moment";
import { useState } from "react";
import { Link } from "react-router";
import DataNotFound from "../ui/loader/data-not-found";


export default function NotificationPanel({ isOpen, notifications, refreshNotifications = () => { }, onCloase = () => { }, refreshLoad, markAsRead, markAsReadOnly, markAllAsRead }) {
    const [ids, setIds] = useState([])
    if (!isOpen) return null;

    return (
        <>
            <div className="fixed w-screen h-screen top-0 bottom-0 left-0 right-0 m-auto bg-[rgba(0,0,0,0.1)] backdrop-blur-[1px] z-20" onClick={() => onCloase()} />
            <div className="absolute right-[0px] top-[32px] mt-2 w-96 backdrop-blur-[4px] bg-gradient-to-br from-white/100 via-gray-200/40 to-gray-300/60 rounded-[15px] shadow-[10px_20px_70px_30px_rgba(0,0,0,0.1)] border border-[rgba(224,224,224,0.5764705882)] z-20">
                <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200">
                    <h3 className="text-lg font-semibold text-gray-900">Notifications</h3>
                    <div className="flex items-center gap-2">

                        <button
                            title="View Detail Page"
                            onClick={() => window.open(`/notification/all`, "_blank")}
                            className="p-2 rounded-md text-gray-600 hover:text-blue-600 hover:bg-gray-100 transition"
                        >
                            <ClipboardPaste size={18} />
                        </button>

                        {/* Refresh */}
                        <button
                            onClick={refreshNotifications}
                            title="Refresh"
                            className="p-2 rounded-md text-gray-600 hover:text-blue-600 hover:bg-gray-100 transition"
                        >
                            <RefreshCw
                                size={18}
                                className={refreshLoad ? "animate-spin" : ""}
                            />
                        </button>

                        {/* Mark all as read */}
                        <button
                            onClick={markAllAsRead}
                            title="Mark all as read"
                            className="p-2 rounded-md text-gray-600 hover:text-green-600 hover:bg-gray-100 transition"
                        >
                            <CheckCheck size={18} />
                        </button>
                    </div>
                </div>

                <div className="max-h-[420px] pb-2 pt-2 overflow-hidden">
                    <div
                        className="max-h-[400px] overflow-y-auto pl-[10px] pr-[10px] bar"
                        style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
                    >
                        {notifications?.length ? (
                            notifications?.map(n => (
                                <Link
                                    to={n?.notificationlink}
                                    key={n.id}
                                    className={`flex flex-col px-3 py-2.5 backdrop-blur-[2px] my-[6px] rounded-[6px] bg-white/30 hover:bg-white/80 transition-colors shadow-[0px_0px_5px_1px_rgba(0,0,0,0.1)]`}
                                    onClick={() => markAsRead(n.id)}
                                >
                                    <p className="text-sm font-medium text-gray-900 mb-1">{n.notificationtext}</p>
                                    <span className="flex items-center justify-between">
                                        <p className="text-xs text-gray-500">{moment.unix(n.notificationtime).format("DD-MMM-YYYY")}</p>
                                        <button
                                            className={`text-xs ${ids.includes(n.id) ? "text-teal-600" : "text-gray-600"} hover:text-teal-500 font-medium`}
                                            onClick={(e) => {
                                                e.preventDefault();   // <-- Prevent Link navigation
                                                e.stopPropagation();  // <-- Stop event bubbling

                                                if (!ids.includes(n.id)) {
                                                    markAsReadOnly(n.id);    // Mark as read
                                                    setIds([...ids, n.id]); // Correctly add ID to state
                                                }
                                            }}
                                        >
                                            <Check size={18} />
                                        </button>
                                    </span>
                                </Link>
                            ))
                        ) : (
                            <div className={`flex flex-col px-3 py-2.5 backdrop-blur-[2px] my-[6px] rounded-[6px] bg-white/30 text-center shadow-[0px_0px_5px_1px_rgba(0,0,0,0.1)]`}>
                                <DataNotFound content={<span>No Notifications Available</span>} />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}
